import React, { useState, useEffect } from "react";
import axios from "axios"; // Import axios
import "../../components/Region/Region.css";

const Region = ({tokenStorage,openProfile,setOpenProfile,regionId}) => {

  const baseAPI = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);
    if (storedToken) {
      axios
        .get(
          `${baseAPI}Adminget/GETRegion?region_id=` +
          regionId,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setFirstItem(response.data.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const [firstItem, setFirstItem] = useState({
    region_id: regionId,
    region_name: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) =>{
    e.preventDefault();
    setFirstItem({
      region_id: regionId,
    });
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}Adminpost/AddRegion`,
        firstItem, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      
      // Optionally, reset the form
      setFirstItem({
        region_name: "",
      });
      tokenStorage();
      setOpenProfile (!openProfile); 
    }catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  return (
    
    <div className="container-fluid">
      <br />

      <div className="regionDetail">
        <form className="region-form">
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Region Name*</td>
              <td>Region Code</td>
            </tr>

            <tr key={firstItem.region_id}>
              <td>
                <input placeholder="Enter Please"  name="region_name" value={firstItem.region_name} onChange={handleChange}/>
              </td>
              <td>
                <input placeholder="Enter Please" />
              </td>
            
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addRegion-button">
          <button  type="submit" onClick={handleSubmit}  style={{marginRight: "10px", backgroundColor: "#5B489D", color: "white"}}>
              Apply
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
           
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default Region;
